import { useTheme } from '@mui/material';
const useCaptureButtonStyles = () => {
    const theme = useTheme();
    return {
        CameraButtonContainer: {
            mt: 'auto',
            pt: '22px',
            pb: '12px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        },
        CaptureButton: {
            display: 'flex',
            width: 48,
            minWidth: 'unset',
            height: 48,
            p: 0.5,
            alignItems: 'center',
            gap: '10px',
            flexShrink: 0,
            borderRadius: '100px',
            border: `2px solid ${theme.palette.primary.main}`,
            transition: 'padding 0.2s ease-in-out, border 0.2s ease-in-out',
            '&:hover': {
                padding: 0,
                border: 0,
            },
            cursor: 'pointer',
        },
        CaptureButtonInner: {
            display: 'flex',
            p: '10px',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '10px',
            flex: '1 0 0',
            alignSelf: 'stretch',
            borderRadius: '100px',
            background: theme.palette.primary.main,
            transition: 'all 0.2s ease-in-out'
        }
    };
};
export default useCaptureButtonStyles;
